import { useContext } from 'react';

import { GoalFormContext } from './goal-form-context';

export const useOpenCreateGoalDialog = () => {
  const { onCreateGoal } = useContext(GoalFormContext);

  return onCreateGoal;
};
